;(function () {
  'use strict'

  angular
    .module('contrast.beta-cve-shields')
    .constant('csBetaCveShields', [
      'cve-2017-0898',
      'cve-2017-12616',
      'cve-2017-12617',
      'cve-2017-14033',
      'cve-2017-14064',
      'cve-2021-44228',
      'cve-2021-45046'
    ])
})()
